import React, { useState, useRef, useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import mxFlag from "../assets/flags/mx.webp";
import usFlag from "../assets/flags/us.webp";

const LANGUAGES = [
  { code: "es", name: "Español", flag: mxFlag },
  { code: "en", name: "English", flag: usFlag },
];

export default function LanguageDropdown() {
  const { lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // cerrar al clickear fuera
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentLang = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Botón que abre el menú */}
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50"
      >
        <img src={currentLang.flag} alt={currentLang.code} className="w-5 h-4 rounded-sm" />
        <span className="font-medium text-gray-700">{currentLang.code.toUpperCase()}</span>
      </button>

      {/* Menú */}
      {open && (
        <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className={`flex items-center gap-2 w-full px-3 py-2 text-sm transition-colors
                ${lang === l.code
                  ? "bg-cyan-500 text-white font-semibold"
                  : "text-gray-700 hover:bg-cyan-50 hover:text-cyan-700"}`}
            >
              <img src={l.flag} alt={l.name} className="w-5 h-4 rounded-sm" />
              {l.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
